(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('propriedadeCardActivity', PropriedadeCardActivity);

  function PropriedadeCardActivity() {
    return {
      restrict: 'E',
      controller: 'PropriedadeCardActivityCtrl',
      controllerAs: 'card',
      templateUrl: 'views/propriedade/propriedade-card-activity.html',
      require: ['propriedadeCardActivity', '^propriedadeCards'],
      scope: {
        activity: '=',
        filters: '<'
      },
      link: function link(scope, element, attrs, controllers) {
        var activity = controllers[0];
        var cards = controllers[1];

        activity.init(cards);
      }
    };
  }

}());
